<template lang="pug">
.run-time-wrap
  .title {{ title }}
  .run-time(v-html="translateTime")
</template>
<script>
export default {
  name: "run-time-wrap",
  props: {
    title: {
      type: String,
      default: "运行时间",
      required: false,
    },
    series: {
      type: [Number, String],
    },
    isHour: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translateTime() {
      if (!this.series) {
        return "未启动";
      }
      let day = Number(this.series) / 60 / 24;
      if (this.isHour) {
        day = day * 60;
      }
      const hours = (day % 1) * 24;
      const minutes = (hours % 1).toFixed(1) * 60;
      return `${Math.floor(day)}<span>天</span>${Math.floor(hours)}<span>时</span>${Math.floor(minutes)}<span>分</span>`;
    },
  },
};
</script>
<style lang="scss" scoped>
.run-time-wrap {
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 0 20px !important;
  box-sizing: border-box;
  position: relative;

  .title {
    font-size: 18px;
    position: absolute;
    top: 10px;
    left: 10px;
  }

  .run-time {
    font-size: 47px;
    font-weight: 300;
    white-space: nowrap;
    text-align: center;
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);

    ::v-deep span {
      font-size: 25px;
    }
  }
}
</style>
